import { Box } from '../Box/Box'
import { DRAWER_PX_PADDING } from './MobileDrawer'
import { forwardRef } from 'react'

export const MobileDrawerFooter = forwardRef<HTMLDivElement, { children?: React.ReactNode }>(
  ({ children }, ref) => (
    <Box
      ref={ref}
      sx={{
        py: 6,
        px: DRAWER_PX_PADDING,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 4
      }}
      data-testid="mobile-drawer-footer"
    >
      {children}
    </Box>
  )
)

MobileDrawerFooter.displayName = 'MobileDrawerFooter'
